import React from 'react';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';
import showConfirmModal from 'components/ConfirmModal';
import { OperationType } from 'screens/Applications&WorkOrders/StepsLayout/Context/AgOperationUtilityProvider';

const showDiscardConfirmModal = (
  onOk: () => void,
  operationType: OperationType = OperationType.APPLICATION
) => {
  showConfirmModal({
    title: LayoutStrings.modal[operationType].discardTitle,
    content: (
      <>
        By leaving the page, you will lose{' '}
        <span className="font-semibold">all data</span> from this record.
      </>
    ),
    okText: LayoutStrings.modal.discardRecord,
    cancelText: LayoutStrings.modal.continueEditing,
    onOk
  });
};

export default showDiscardConfirmModal;
